/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Fuehrungszeugnisausstellung1Inputs */



/**

* @param {_Field_Fuehrungszeugnisausstellung1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_fuehrungszeugnisausstellung1 = /** @type {((inputs?: _Field_Fuehrungszeugnisausstellung1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Fuehrungszeugnisausstellung1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Führungszeugnis Ausstellung")
});
export { _field_fuehrungszeugnisausstellung1 as "_field_fuehrungszeugnisAusstellung" }